import { Action } from "@ngrx/store";
import { ReduxAction } from "./redux.action";
import { UtilService } from "../services";

export class SetTestOrderSearchCriteria implements ReduxAction {
  type: string = "SET_TEST_ORDER_SEARCH_CRITERIA";
  SearchCriteria: SearchCriteria;

  constructor(searchCriteria: SearchCriteria) {
    this.SearchCriteria = searchCriteria;
  }

  get() {
    return this.SearchCriteria;
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/actions/test-order-search.actions.ts